import { ITenantConfig } from '../tenant.interface';

export const ABCL_TENANT: ITenantConfig = {
  id: 'ABCL',
  displayName: 'Aditya Birla Capital',
  logo: 'assets/logos/doqfy_logo.png',
  favicon: 'assets/logos/small_logo.png',
  theme: {
    primaryColor:  '#e2171d',
    primaryDark:   '#b50000',
    secondaryColor: '#1a1a2e',
    accentColor:   '#f5a623',
    fontFamily:    '"Poppins", sans-serif',
    logoUrl:       'assets/logos/doqfy_logo.png',
    logoHeight:    '35px',
  },
  auth: {
    type: 'cyberark',
    msalClientId: 'd443367d-5b91-4695-8525-f3ad63cfc3c0',
    cyberark: {
      uatUrl: 'https://aaq4824.id.cyberark.cloud/OAuth2/Authorize/abcldoqfyuat?response_type=code&client_id=64aceba3-add9-4299-a71f-d27773bae8bc&client_secret=cldoqfyuat&redirect_uri=https://uat.doqfy.in/cyberark-login&scope=openid&state=abc&nonce=',
      prodUrl: 'https://aaq4824.id.cyberark.cloud/OAuth2/Authorize/abcldoqfyprod?response_type=code&client_id=1755ebe6-8dea-4d70-a703-36f0d197a443&client_secret=cldoqfyprod&redirect_uri=https://prod.doqfy.in/cyberark-login&scope=openid&state=abc&nonce=',
      hostIdentifier: 'abcl',
    },
  },
  features: {
    estamp: true,
    esign: true,
    inventory: false,
    bulkUpload: true,
    reports: true,
    preProcurement: false,
    walletManagement: false,
    userManagement: true,
    catExecution: true,
  },
  domains: ['abcl.doqfy.in', 'abcluat.doqfy.in'],
};
